export default __webpack_public_path__ + "static/go-live-support-b02ad7de0b697d019f78c69ecef7b9b8.jpg";